export default __webpack_public_path__ + "static/step3-78c8f4dd3a2c87ed225f4c9097904667.jpg";